export const Shoe = [
 
  {
    title: "Adidas Next Level Speed Basketball Shoes",
    desc: "This cool adidas Next Level Speed basketball shoes for men are dedicated to keep the defense a step behind. Featuring rich materials, TORSIONÂ® stability and the addition of a cushioned GEOFITâ„¢ ankle collar for four-plus quarters of comfort, this is a perfect boot to rule over the court. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADBSS83650L.jpg",
    currency: "INR ",
    price: "6699",
    mrp: "4689",
    discount: "30% off",
  },
  {
    title: "Nike Air Quick Handle Basketball Shoes",
    desc: "Nike Air Quick Handle Basketball Shoes ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "4595",
    mrp: "4365",
    discount: "5% off",
  },
  {
    title: "Nike Prime Hype DF Basketball Shoes",
    desc: "Nike Prime Hype DF Basketball Shoes ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "6495",
    mrp: "6495",
    discount: "0% off",
  },
  {
    title: "Nike Air Visi Pro VI Basketball Shoes",
    desc: "Nike Air Visi Pro VI Basketball Shoes ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "5795",
    mrp: "5795",
    discount: "0% off",
  },
  {
    title: "Adidas D Lillard Basketball Shoes",
    desc: "Adidas D Lillard Basketball Shoes ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "9999",
    mrp: "6999",
    discount: "30% off",
  },
  {
    title: "Adidas Isolation 2 Basketball Shoes (Grey/White)",
    desc: "Adidas Isolation 2 Basketball Shoes (Grey/White) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "4999",
    mrp: "3499",
    discount: "30% off",
  },
  {
    title: "Nike AIR Overplay IX Basketball Shoes (Black/White/Dark Grey)",
    desc: "Nike AIR Overplay IX Basketball Shoes (Black/White/Dark Grey) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "4995",
    mrp: "4995",
    discount: "0% off",
  },
];
